import api from '../../services/api';

const baseUrl = 'financial/billings';

const findByRequestId = async (requestId) =>
    api.get({ type: 'user', service: `${baseUrl}/request/${requestId}` });

export default {
    findByRequestId
}